/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@material-ui/core/SvgIcon';
import _ from 'lodash';

const Icon = (props) => {
    const { path, ...rest } = props;
    return (
        <SvgIcon {...rest}>
            {_.isArray(path) ? path.map((p) => <path d={p} key={p} />) : <path d={path} />}
        </SvgIcon>
    );
};

Icon.propTypes = {
    path: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired,
};

export default Icon;

export const CancelIcon = (props) => {
    const { size, color } = props;
    return <Icon style={{ fontSize: size, color }} path="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />;
};

CancelIcon.defaultProps = {
    size: '24px',
    color: '',
};

CancelIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const MenuIcon = (props) => {
    const { size, color } = props;
    return <Icon style={{ fontSize: size, color }} path="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />;
};

MenuIcon.defaultProps = {
    size: '24px',
    color: '',
};

MenuIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const SearchIcon = (props) => {
    const { size, color } = props;
    return <Icon style={{ fontSize: size, color }} path="M21.7832 20.7424L16.7626 15.7291C18.3659 13.8585 19.1824 11.4396 19.0406 8.97991C18.8989 6.52026 17.8099 4.21115 16.0022 2.53716C14.1945 0.863179 11.8086 -0.0455251 9.34536 0.00175677C6.88208 0.0490386 4.53287 1.04863 2.79075 2.79075C1.04863 4.53287 0.0490386 6.88208 0.00175677 9.34536C-0.0455251 11.8086 0.863179 14.1945 2.53716 16.0022C4.21115 17.8099 6.52026 18.8989 8.97991 19.0406C11.4396 19.1824 13.8585 18.3659 15.7291 16.7626L20.7424 21.7832C20.8106 21.8519 20.8916 21.9064 20.9809 21.9436C21.0703 21.9808 21.1661 22 21.2628 22C21.3596 22 21.4554 21.9808 21.5447 21.9436C21.634 21.9064 21.7151 21.8519 21.7832 21.7832C21.8519 21.7151 21.9064 21.634 21.9436 21.5447C21.9808 21.4554 22 21.3596 22 21.2628C22 21.1661 21.9808 21.0703 21.9436 20.9809C21.9064 20.8916 21.8519 20.8106 21.7832 20.7424ZM1.47344 9.53578C1.47344 7.9412 1.94629 6.38243 2.83219 5.05658C3.71809 3.73074 4.97725 2.69737 6.45045 2.08715C7.92365 1.47693 9.54472 1.31727 11.1087 1.62836C12.6726 1.93944 14.1092 2.70731 15.2367 3.83484C16.3642 4.96238 17.1321 6.39895 17.4432 7.96289C17.7543 9.52683 17.5946 11.1479 16.9844 12.6211C16.3742 14.0943 15.3408 15.3535 14.015 16.2394C12.6891 17.1253 11.1304 17.5981 9.53578 17.5981C7.39751 17.5981 5.34683 16.7487 3.83484 15.2367C2.32286 13.7247 1.47344 11.674 1.47344 9.53578Z" />;
};

SearchIcon.defaultProps = {
    size: '24px',
    color: '',
};

SearchIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const FacebookIcon = (props) => {
    const { size, color } = props;
    return <Icon style={{ fontSize: size, color }} path="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m13 2h-2.5A3.5 3.5 0 0 0 12 8.5V11h-2v3h2v7h3v-7h3v-3h-3V9a1 1 0 0 1 1-1h2V5z" />;
};

FacebookIcon.defaultProps = {
    size: '24px',
    color: '',
};

FacebookIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const InstagramIcon = (props) => {
    const { size, color } = props;
    return <Icon style={{ fontSize: size, color }} path="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4H7.6m9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8 1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5 5 5 0 0 1-5 5 5 5 0 0 1-5-5 5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3z" />;
};

InstagramIcon.defaultProps = {
    size: '24px',
    color: '',
};

InstagramIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const TwitterIcon = (props) => {
    const { size, color } = props;
    return <Icon style={{ fontSize: size, color }} path="M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.71 0-1.37-.2-1.95-.5v.03c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 0 1-1.93.07 4.28 4.28 0 0 0 4 2.98 8.521 8.521 0 0 1-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21 16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56.84-.6 1.56-1.36 2.14-2.23z" />;
};

TwitterIcon.defaultProps = {
    size: '24px',
    color: '',
};

TwitterIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const YoutubeIcon = (props) => {
    const { size, color } = props;
    return <Icon style={{ fontSize: size, color }} path="M10 15l5.19-3L10 9v6m11.56-7.83c.13.47.22 1.1.28 1.9.07.8.1 1.49.1 2.09L22 12c0 2.19-.16 3.8-.44 4.83-.25.9-.83 1.48-1.73 1.73-.47.13-1.33.22-2.65.28-1.3.07-2.49.1-3.59.1L12 19c-4.19 0-6.8-.16-7.83-.44-.9-.25-1.48-.83-1.73-1.73-.13-.47-.22-1.1-.28-1.9-.07-.8-.1-1.49-.1-2.09L2 12c0-2.19.16-3.8.44-4.83.25-.9.83-1.48 1.73-1.73.47-.13 1.33-.22 2.65-.28 1.3-.07 2.49-.1 3.59-.1L12 5c4.19 0 6.8.16 7.83.44.9.25 1.48.83 1.73 1.73z" />;
};

YoutubeIcon.defaultProps = {
    size: '24px',
    color: '',
};

YoutubeIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const RssFeedIcon = (props) => {
    const { size, color } = props;
    return <Icon style={{ fontSize: size, color }} path="M4 4.44v2.83c7.03 0 12.73 5.7 12.73 12.73h2.83c0-8.59-6.97-15.56-15.56-15.56zm0 5.66v2.83c3.9 0 7.07 3.17 7.07 7.07h2.83c0-5.47-4.43-9.9-9.9-9.9z" />;
};

RssFeedIcon.defaultProps = {
    size: '24px',
    color: '',
};

RssFeedIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const DashboardIcon = (props) => {
    const { size, color } = props;
    return <Icon style={{ fontSize: size, color }} path="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z" />;
};

DashboardIcon.defaultProps = {
    size: '24px',
    color: '',
};

DashboardIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const AddPhotoAlternateOutlinedIcon = (props) => {
    const { size, color } = props;
    return <Icon style={{ fontSize: size, color }} path="M19 7v2.99s-1.99.01-2 0V7h-3s.01-1.99 0-2h3V2h2v3h3v2h-3zm-3 4V8h-3V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8h-3zM5 19l3-4 2 3 3-4 4 5H5z" />;
};

AddPhotoAlternateOutlinedIcon.defaultProps = {

    size: '24px',
    color: '',
};

AddPhotoAlternateOutlinedIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const LogOutIcon = (props) => {
    const { size, color } = props;
    return <Icon style={{ fontSize: size, color }} path="M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" />;
};

LogOutIcon.defaultProps = {
    size: '24px',
    color: '',
};

LogOutIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};
export const TooltipIcon = (props) => {
    const { size, color } = props;
    return <Icon style={{ fontSize: size, color }} path="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z" />;
};

TooltipIcon.defaultProps = {
    size: '24px',
    color: '',
};

TooltipIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};
export const VisibilityIcon = (props) => {
    const { size, color } = props;
    return <Icon style={{ fontSize: size, color }} path="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />;
};

VisibilityIcon.defaultProps = {
    size: '24px',
    color: '#ccc',
};

VisibilityIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};
export const VisibilityOffIcon = (props) => {
    const { size, color } = props;
    return <Icon style={{ fontSize: size, color }} path="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z" />;
};

VisibilityOffIcon.defaultProps = {
    size: '24px',
    color: '#ccc',
};

VisibilityOffIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const Trash = (props) => {
    const { size, color } = props;
    return <Icon style={{ fontSize: size, color }} path="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />;
};

Trash.defaultProps = {
    size: '24px',
    color: '',
};

Trash.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const Create = (props) => {
    const { size, color } = props;
    return <Icon style={{ fontSize: size, color }} path="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />;
};

Create.defaultProps = {
    size: '24px',
    color: '',
};

Create.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const UploadIcon = (props) => {
    const { size, color } = props;
    return <Icon style={{ fontSize: size, color }} path="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z" />;
};

UploadIcon.defaultProps = {
    size: '24px',
    color: '',
};

UploadIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const IndeterminateCheckBoxIcon = (props) => {
    const { size, color } = props;
    return (
        <Icon
            style={{ fontSize: size, color }}
            path="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
        />
    );
};

IndeterminateCheckBoxIcon.defaultProps = {
    size: '24px',
    color: '',
};

IndeterminateCheckBoxIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const StoreIcon = (props) => {
    const { size, color } = props;
    return <Icon style={{ fontSize: size, color }} path="M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z" />;
};

StoreIcon.defaultProps = {
    size: '24px',
    color: '',
};

StoreIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const AddBoxIcon = (props) => {
    const { size, color } = props;
    return (
        <Icon
            style={{ fontSize: size, color }}
            path="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
        />
    );
};

AddBoxIcon.defaultProps = {
    size: '24px',
    color: '',
};

AddBoxIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const GroupIcon = (props) => {
    const { size, color } = props;
    return <Icon style={{ fontSize: size, color }} path="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />;
};

GroupIcon.defaultProps = {
    size: '24px',
    color: '',
};

GroupIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const Company = (props) => {
    const { size, color } = props;
    return <Icon style={{ fontSize: size, color }} path="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z" />;
};

Company.defaultProps = {
    size: '24px',
    color: '',
};

Company.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};
export const Calendar = (props) => {
    const { size, color } = props;
    return <Icon style={{ fontSize: size, color }} path="M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z" />;
};

Calendar.defaultProps = {
    size: '24px',
    color: '',
};

Calendar.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const TelegramIcon = (props) => {
    const { size, color } = props;
    return <Icon style={{ fontSize: size, color }} path="M9.78 18.65l.28-4.23 7.68-6.92c.34-.31-.07-.46-.52-.19L7.74 13.3 3.64 12c-.88-.25-.89-.86.2-1.3l15.97-6.16c.73-.33 1.43.18 1.15 1.3l-2.72 12.81c-.19.91-.74 1.13-1.5.71L12.6 16.3l-1.99 1.93c-.23.23-.42.42-.83.42z" />;
};

TelegramIcon.defaultProps = {
    size: '24px',
    color: '',
};

TelegramIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const VideoCam = (props) => {
    const { size, color } = props;
    return <Icon style={{ fontSize: size, color }} path="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z" />;
};

VideoCam.defaultProps = {
    size: '24px',
    color: '',
};

VideoCam.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const Image = (props) => {
    const { size, color } = props;
    return <Icon style={{ fontSize: size, color }} path="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z" />;
};

Image.defaultProps = {
    size: '24px',
    color: '',
};

Image.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const Mic = (props) => {
    const { size, color } = props;
    return <Icon style={{ fontSize: size, color }} path="M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z" />;
};

Mic.defaultProps = {
    size: '24px',
    color: '',
};

Mic.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};
export const OrganizerIcon = (props) => {
    const { size, color } = props;
    return <Icon style={{ fontSize: size, color }} path="M21 5v14h2V5h-2zm-4 14h2V5h-2v14zM14 5H2c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zM8 7.75c1.24 0 2.25 1.01 2.25 2.25S9.24 12.25 8 12.25 5.75 11.24 5.75 10 6.76 7.75 8 7.75zM12.5 17h-9v-.75c0-1.5 3-2.25 4.5-2.25s4.5.75 4.5 2.25V17z" />;
};

OrganizerIcon.defaultProps = {
    size: '24px',
    color: '',
};

OrganizerIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};
export const RoomIcon = (props) => {
    const { size, color } = props;
    return <Icon style={{ fontSize: size, color }} path="M14 6v15H3v-2h2V3h9v1h5v15h2v2h-4V6h-3zm-4 5v2h2v-2h-2z" />;
};

RoomIcon.defaultProps = {
    size: '24px',
    color: '',
};

RoomIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};
export const SeminarIcon = (props) => {
    const { size, color } = props;
    return <Icon style={{ fontSize: size, color }} path="M13 9.5h5v-2h-5v2zm0 7h5v-2h-5v2zm6 4.5H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2zM6 11h5V6H6v5zm1-4h3v3H7V7zM6 18h5v-5H6v5zm1-4h3v3H7v-3z" />;
};

SeminarIcon.defaultProps = {
    size: '24px',
    color: '',
};

SeminarIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};
export const ProductIcon = (props) => {
    const { size, color } = props;
    return <Icon style={{ fontSize: size, color }} path="M10 16v-1H3.01L3 19c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2v-4h-7v1h-4zm10-9h-4.01V5l-2-2h-4l-2 2v2H4c-1.1 0-2 .9-2 2v3c0 1.11.89 2 2 2h6v-2h4v2h6c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm-6 0h-4V5h4v2z" />;
};

ProductIcon.defaultProps = {
    size: '24px',
    color: '',
};

ProductIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const PollIcon = (props) => {
    const { size, color } = props;
    return <Icon style={{ fontSize: size, color }} path="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z" />;
};

PollIcon.defaultProps = {
    size: '24px',
    color: '',
};

PollIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const ListedIcon = (props) => {
    const { size, color } = props;
    return <Icon style={{ fontSize: size, color }} path="M14 10H2v2h12v-2zm0-4H2v2h12V6zM2 16h8v-2H2v2zm19.5-4.5L23 13l-6.99 7-4.51-4.5L13 14l3.01 3 5.49-5.5z" />;
};

ListedIcon.defaultProps = {
    size: '24px',
    color: '',
};

ListedIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};
export const FAQIcon = (props) => {
    const { size, color } = props;
    return <Icon style={{ fontSize: size, color }} path="M11.5 2C6.81 2 3 5.81 3 10.5S6.81 19 11.5 19h.5v3c4.86-2.34 8-7 8-11.5C20 5.81 16.19 2 11.5 2zm1 14.5h-2v-2h2v2zm0-3.5h-2c0-3.25 3-3 3-5 0-1.1-.9-2-2-2s-2 .9-2 2h-2c0-2.21 1.79-4 4-4s4 1.79 4 4c0 2.5-3 2.75-3 5z" />;
};

FAQIcon.defaultProps = {
    size: '24px',
    color: '',
};

FAQIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};
export const ContactIcon = (props) => {
    const { size, color } = props;
    return <Icon style={{ fontSize: size, color }} path="M21 5v14h2V5h-2zm-4 14h2V5h-2v14zM14 5H2c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zM8 7.75c1.24 0 2.25 1.01 2.25 2.25S9.24 12.25 8 12.25 5.75 11.24 5.75 10 6.76 7.75 8 7.75zM12.5 17h-9v-.75c0-1.5 3-2.25 4.5-2.25s4.5.75 4.5 2.25V17z" />;
};

ContactIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

ContactIcon.defaultProps = {
    size: '24px',
    color: '',
};

export const LiveHelpIcon = (props) => {
    const { size, color } = props;
    return <Icon style={{ fontSize: size, color }} path="M19 2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 16h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 11.9 13 12.5 13 14h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z" />;
};

LiveHelpIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

LiveHelpIcon.defaultProps = {
    size: '24px',
    color: '',
};

export const AdvertisementIcon = (props) => {
    const { size, color } = props;
    return (
        <Icon
            style={{ fontSize: size, color }}
            path={[
                'm12.97 14.832c.585.585 1.536.585 2.121 0s.585-1.536 0-2.121z',
                'm10.495 8.822-.707.707.707.707.707-.707c.195-.195.195-.512 0-.707s-.512-.196-.707 0z',
                'm23.201 11.938-10.925-11.151c-.506-.517-1.211-.812-1.935-.812-.001 0-.003 0-.005 0l-8.616.021c-.949.002-1.722.775-1.724 1.724l-.021 8.617c-.001.725.295 1.432.812 1.939l11.151 10.925c.524.514 1.209.77 1.894.77.694 0 1.388-.263 1.914-.789l7.436-7.436c1.045-1.045 1.053-2.753.019-3.808zm-18.201-4.938c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm4.965 5.887c-.293.293-.768.293-1.061 0s-.293-.768 0-1.061l.53-.53-.707-.707-.53.53c-.293.293-.768.293-1.061 0s-.293-.768 0-1.061l2.298-2.298c.78-.78 2.048-.78 2.828 0s.78 2.048 0 2.828zm6.187 3.006c-1.17 1.17-3.073 1.17-4.243 0l-.53-.53c-.293-.293-.293-.768 0-1.061l3.182-3.182c.293-.293.768-.293 1.061 0l.53.53c1.17 1.17 1.17 3.073 0 4.243z',
            ]}
        />
    );
};

AdvertisementIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

AdvertisementIcon.defaultProps = {
    size: '24px',
    color: '',
};
export const QAIcon = (props) => {
    const { size, color } = props;
    return (
        <Icon
            style={{ fontSize: size, color }}
            path={[
                'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z',
            ]}
        />
    );
};

QAIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

QAIcon.defaultProps = {
    size: '24px',
    color: '',
};

export const RegisterIcon = (props) => {
    const { size, color } = props;
    return (
        <Icon
            style={{ fontSize: size, color }}
            path={[
                'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z',
            ]}
        />
    );
};

RegisterIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

RegisterIcon.defaultProps = {
    size: '24px',
    color: '',
};

export const CheckIcon = (props) => {
    const { size, color } = props;
    return (
        <Icon
            style={{ fontSize: size, color }}
            path="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
        />
    );
};

CheckIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

CheckIcon.defaultProps = {
    size: '24px',
    color: '',
};
export const LoadMoreIcon = (props) => {
    const { size, color } = props;
    return (
        <Icon
            style={{ fontSize: size, color }}
            path="M14 10H2v2h12v-2zm0-4H2v2h12V6zm4 8v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zM2 16h8v-2H2v2z"
        />
    );
};

LoadMoreIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

LoadMoreIcon.defaultProps = {
    size: '24px',
    color: '',
};
export const BackToTop = (props) => {
    const { size, color } = props;
    return (
        <Icon
            style={{ fontSize: size, color }}
            path="M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
        />
    );
};

BackToTop.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

BackToTop.defaultProps = {
    size: '24px',
    color: '',
};
export const RadioButtonIcon = (props) => {
    const { size, color } = props;
    return (
        <Icon
            style={{ fontSize: size, color }}
            path="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
        />
    );
};

RadioButtonIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

RadioButtonIcon.defaultProps = {
    size: '24px',
    color: '#4FACFE',
};
export const DownloadIcon = (props) => {
    const { size, color } = props;
    return (
        <Icon
            style={{ fontSize: size, color }}
            path="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"
        />
    );
};

DownloadIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

DownloadIcon.defaultProps = {
    size: '24px',
    color: '',
};

export const HeadsetIcon = (props) => {
    const { size, color } = props;
    return (
        <Icon
            style={{ fontSize: size, color }}
            path="M12 1c-4.97 0-9 4.03-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h3c1.66 0 3-1.34 3-3v-7c0-4.97-4.03-9-9-9z"
        />
    );
};

HeadsetIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

HeadsetIcon.defaultProps = {
    size: '24px',
    color: '',
};

export const ViewListIcon = (props) => {
    const { size, color } = props;
    return (
        <Icon
            style={{ fontSize: size, color }}
            path="M4 14h4v-4H4v4zm0 5h4v-4H4v4zM4 9h4V5H4v4zm5 5h12v-4H9v4zm0 5h12v-4H9v4zM9 5v4h12V5H9z"
        />
    );
};

ViewListIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

ViewListIcon.defaultProps = {
    size: '24px',
    color: '',
};

export const PlayIcon = (props) => {
    const { size, color } = props;
    return (
        <Icon
            style={{ fontSize: size, color }}
            path="M8 5v14l11-7z"
        />
    );
};

PlayIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

PlayIcon.defaultProps = {
    size: '24px',
    color: '',
};

export const SurveyIcon = (props) => {
    const { size, color } = props;
    return (
        <Icon
            style={{ fontSize: size, color }}
            path="M17 10H7v2h10v-2zm2-7h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zm-5-5H7v2h7v-2z"
        />
    );
};

SurveyIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

SurveyIcon.defaultProps = {
    size: '24px',
    color: '',
};

export const CancelIconDialog = (props) => {
    const { size, color } = props;
    return (
        <Icon
            style={{
                fontSize: size, color,
            }}
            path="M 19.935 6.116 L 16.953 3.077 L 11 9 L 4.968 2.962 L 1.987 6.058 L 8 12 L 1.929 17.986 L 4.968 20.853 L 11 15 L 16.895 20.967 L 20.107 17.986 L 14.028 12.022 z"
        />
    );
};

CancelIconDialog.defaultProps = {
    size: '30px',
    color: 'white',
};

CancelIconDialog.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const AddCircleIcon = (props) => {
    const { size, color } = props;
    return (
        <Icon
            style={{
                fontSize: size, color,
            }}
            path="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
        />
    );
};

AddCircleIcon.defaultProps = {
    size: '24px',
    color: 'blue',
};

AddCircleIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const RemoveCircleIcon = (props) => {
    const { size, color } = props;
    return (
        <Icon
            style={{
                fontSize: size, color,
            }}
            path="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z"
        />
    );
};

RemoveCircleIcon.defaultProps = {
    size: '24px',
    color: 'red',
};

RemoveCircleIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const NavigateNextIcon = (props) => {
    const { size, color } = props;
    return (
        <Icon
            style={{
                fontSize: size, color,
            }}
            path="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
        />
    );
};

NavigateNextIcon.defaultProps = {
    size: '24px',
    color: '#fff',
};

NavigateNextIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const NavigateBeforeIcon = (props) => {
    const { size, color } = props;
    return (
        <Icon
            style={{
                fontSize: size, color,
            }}
            path="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
        />
    );
};

NavigateBeforeIcon.defaultProps = {
    size: '24px',
    color: '#fff',
};

NavigateBeforeIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const ArrowUpward = (props) => {
    const { size, color } = props;
    return (
        <Icon
            style={{
                fontSize: size, color,
            }}
            path="M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
        />
    );
};

ArrowUpward.defaultProps = {
    size: '24px',
    color: '',
};

ArrowUpward.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const ArrowDownward = (props) => {
    const { size, color } = props;
    return (
        <Icon
            style={{
                fontSize: size, color,
            }}
            path="M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
        />
    );
};

ArrowDownward.defaultProps = {
    size: '24px',
    color: '',
};

ArrowDownward.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const PlayCircleFilled = (props) => {
    const { size, color } = props;
    return (
        <Icon
            style={{
                fontSize: size, color,
            }}
            path="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z"
        />
    );
};

PlayCircleFilled.defaultProps = {
    size: '24px',
    color: '',
};

PlayCircleFilled.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const LiveStreamIcon = (props) => {
    const { size, color } = props;
    return (
        <Icon
            style={{
                fontSize: size, color,
            }}
            path="M21 6h-7.59l3.29-3.29L16 2l-4 4-4-4-.71.71L10.59 6H3c-1.1 0-2 .89-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.11-.9-2-2-2zm0 14H3V8h18v12zM9 10v8l7-4z"
        />
    );
};

LiveStreamIcon.defaultProps = {
    size: '24px',
    color: '',
};

LiveStreamIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const FileAudio = (props) => {
    const { size, color } = props;
    return (
        <Icon
            style={{
                fontSize: size, color,
            }}
            path="M18.5 12c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM5 9v6h4l5 5V4L9 9H5z"

        />
    );
};

FileAudio.defaultProps = {
    size: '24px',
    color: '',
};

FileAudio.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const KeyboardBackspaceSharp = (props) => {
    const { size, color } = props;
    return (
        <Icon
            style={{
                fontSize: size, color,
            }}
            path="M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21v-2z"
        />
    );
};

KeyboardBackspaceSharp.defaultProps = {
    size: '24px',
    color: '',
};

KeyboardBackspaceSharp.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const MailIcon = (props) => {
    const { size, color } = props;
    return (
        <Icon
            style={{
                fontSize: size, color,
            }}
            path="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
        />
    );
};

MailIcon.defaultProps = {
    size: '24px',
    color: '',
};

MailIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const SettingShopping = (props) => {
    const { size, color } = props;
    return (
        <svg version="1.1" id="_x32_" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style={{ width: size, opacity: 1, color }} xmlSpace="preserve">
            <g>
                <path
                    fill={color}
                    d="M426.093,0c-9.344,0-17.502,6.318-19.838,15.363l-20.277,78.574H28.775c-6.434,0-12.496,3.025-16.363,8.166 c-3.867,5.144-5.096,11.805-3.316,17.994l58.826,204.123c2.526,8.771,10.557,14.814,19.682,14.814H322.73l-8.858,34.324H89.396 v36.133h236.594c9.342,0,17.5-6.324,19.836-15.373l92.383-357.988h65.496V0H426.093z M349.925,233.652l-17.871,69.25h-45.133 v-69.25H349.925z M376.653,130.068l-17.406,67.453h-72.326v-67.453H376.653z M250.79,233.652v69.25h-77.084v-69.25H250.79z M250.79,130.068v67.453h-77.084v-67.453H250.79z M143.361,130.068v67.453H69.009l-19.436-67.453H143.361z M143.361,233.652v69.25 H99.374l-19.955-69.25H143.361z"
                    style={{ fill: color }}
                />
                <path
                    fill={color}
                    d="M123.903,436.688c-20.23,0-36.633,16.402-36.633,36.64c0,20.234,16.402,36.635,36.633,36.635 c20.24,0,36.633-16.4,36.633-36.635C160.536,453.09,144.144,436.688,123.903,436.688z"
                    style={{ fill: color }}
                />
                <path
                    fill={color}
                    d="M299.681,438.728c-20.24,0-36.633,16.408-36.633,36.633c0,20.24,16.392,36.639,36.633,36.639 c20.23,0,36.633-16.398,36.633-36.639C336.314,455.137,319.911,438.728,299.681,438.728z"
                    style={{ fill: color }}
                />
            </g>
        </svg>
    );
};

SettingShopping.defaultProps = {
    size: '24px',
    color: '#ffffff',
};

SettingShopping.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const RegisterLiveStream = (props) => {
    const { size, color } = props;
    return (
        <svg version="1.1" id="_x32_" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style={{ opacity: 0.8 }} xmlSpace="preserve">
            <g>
                <path
                    fill={color}
                    d="M503.467,21.068H8.533C3.84,21.068,0,24.908,0,29.601v372.797c0,4.693,3.84,8.533,8.533,8.533h494.934
                    c4.693,0,8.533-3.84,8.533-8.533V29.601C512,24.908,508.16,21.068,503.467,21.068z M455.463,77.61v276.788H56.537V77.609h398.348
                    L455.463,77.61z"
                    style={{ fill: color }}
                />
                <path
                    fill={color}
                    d="M399.453,443.172c0.002-0.081,0.014-0.159,0.014-0.24H112.533c0,26.51,21.49,48,48,48h190.934
                    c25.973,0,47.074-20.644,47.92-46.412c0.016-0.452,0.076-0.894,0.08-1.348H399.453z"
                    style={{ fill: color }}
                />
                <polygon
                    fill={color}
                    points="330.881,216.207 330.762,216.137 331,216 253.797,171.427 215.24,149.028 215.24,149.166 215,149.027
                    215,282.972 292.092,238.463"
                    style={{ fill: color }}
                />
            </g>
        </svg>
    );
};

RegisterLiveStream.defaultProps = {
    size: '24px',
    color: '#ffffff',
};

RegisterLiveStream.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const ProductPayment = (props) => {
    const { size, color } = props;
    return (
        <svg version="1.1" id="_x32_" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style={{ width: size, opacity: 1 }} xmlSpace="preserve">
            <g>
                <polygon
                    fill={color}
                    points="257.194,382.917 258.455,318.647 222.489,318.647 223.742,382.917"
                    style={{ fill: color }}
                />
                <polygon
                    fill={color}
                    points="388.436,291.759 393.321,236.081 353.03,236.081 349.884,291.759"
                    style={{ fill: color }}
                />
                <polygon
                    fill={color}
                    points="285.935,291.759 322.914,291.759 326.061,236.081 287.04,236.081"
                    style={{ fill: color }}
                />
                <polygon
                    fill={color}
                    points="321.398,318.647 285.416,318.647 284.156,382.917 317.766,382.917"
                    style={{ fill: color }}
                />
                <polygon
                    fill={color}
                    points="260.078,236.081 220.866,236.081 221.954,291.759 258.982,291.759"
                    style={{ fill: color }}
                />
                <polygon
                    fill={color}
                    points="196.78,382.917 195.52,318.647 159.53,318.647 163.178,382.917"
                    style={{ fill: color }}
                />
                <polygon
                    fill={color}
                    points="154.866,236.081 158.022,291.759 194.992,291.759 193.905,236.081"
                    style={{ fill: color }}
                />
                <path
                    fill={color}
                    d="M107.509,382.917H136.2l-3.624-64.27H94.872l5.033,57.301C100.243,379.894,103.554,382.917,107.509,382.917z"
                    style={{ fill: color }}
                />
                <polygon
                    fill={color}
                    points="87.615,236.081 92.508,291.759 131.052,291.759 127.905,236.081"
                    style={{ fill: color }}
                />
                <path
                    fill={color}
                    d="M98.093,410.694c-6.87,0-13.123-2.57-17.917-6.862c-4.786-4.299-8.015-10.23-8.764-17.068l-0.017-0.123
                    l-0.016-0.19L48.247,215.842h384.442l-9.68,71.437c8.287,0.082,16.319,1.178,24.063,3.048l10.47-77.236h2.24
                    c13.666,0,24.754-11.088,24.754-24.754v-11.616c0-13.674-11.088-24.753-24.754-24.753h-50.076h-39.978h-43.692l74.114-54.566
                    l-0.008-0.017c4.835-3.41,8.617-7.858,11.153-12.818c2.587-5.058,3.921-10.643,3.93-16.294c0-6.985-2.084-14.12-6.352-20.281
                    l0.008,0.008l-3.344-4.836l-0.016-0.009c-3.428-4.966-7.974-8.838-13.04-11.426c-5.058-2.586-10.635-3.921-16.286-3.921
                    c-6.994-0.008-14.128,2.076-20.272,6.351l-0.14,0.083l-147.215,108.39l0.017,0.008c-3.666,2.586-6.722,5.766-9.094,9.325h-84.683
                    H74.822H24.753C11.079,151.968,0,163.047,0,176.721v11.616c0,13.205,10.354,23.972,23.394,24.68l23.947,176.688h0.008
                    c1.474,12.801,7.636,24.128,16.632,32.185c9.061,8.138,21.097,13.056,34.112,13.056H323.17c-3.18-7.67-5.396-15.816-6.714-24.252
                    H98.093z M219.004,166.515c0.841-1.607,2.027-3.016,3.658-4.152l0.166-0.107L369.761,54.072c2.01-1.376,4.202-2.01,6.434-2.01
                    c1.82,0,3.633,0.429,5.239,1.26c1.614,0.824,3.032,2.018,4.168,3.649l-0.016-0.008l3.353,4.835v0.008
                    c1.392,2.018,2.026,4.209,2.035,6.466c0,1.812-0.429,3.625-1.261,5.239c-0.84,1.614-2.026,3.031-3.657,4.159l-0.132,0.091
                    L238.965,185.964c-2.01,1.376-4.202,2.01-6.442,2.018c-1.813,0-3.625-0.437-5.239-1.268c-1.614-0.824-3.015-2.026-4.152-3.649
                    l-3.353-4.836v0.008c-1.392-2.018-2.018-4.218-2.026-6.475C217.752,169.95,218.181,168.13,219.004,166.515z"
                    style={{ fill: color }}
                />
                <path
                    fill={color}
                    d="M421.955,304.091c-49.739,0-90.045,40.315-90.045,90.054c0,49.73,40.306,90.045,90.045,90.045
                    c49.73,0,90.045-40.315,90.045-90.045C512,344.406,471.685,304.091,421.955,304.091z M416.847,436.206l-43.05-34.441l16.336-20.421
                    l22.34,17.876l37.637-48.388l20.652,16.056L416.847,436.206z"
                    style={{ fill: color }}
                />
            </g>
        </svg>
    );
};

ProductPayment.defaultProps = {
    size: '24px',
    color: '#fff',
};

ProductPayment.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const SettingSellProduct = (props) => {
    const { size, color } = props;
    return (
        <svg version="1.1" id="_x31_0" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style={{ width: size, opacity: 1 }} xmlSpace="preserve">
            <g>
                <path
                    fill={color}
                    d="M446.277,0H65.723H39.02v26.703v438.218C39.02,490.879,60.14,512,86.098,512h339.808
                    c25.958,0,47.074-21.121,47.074-47.078V26.703V0H446.277z M65.723,67.742V26.703h380.554v41.039H65.723z M425.906,485.297H86.098
                    c-11.254,0-20.375-9.121-20.375-20.375V89.106h380.554v375.816C446.277,476.176,437.16,485.297,425.906,485.297z"
                    style={{ fill: color }}
                />
                <polygon
                    fill={color}
                    points="158.285,179.422 158.211,179.5 135.262,156.547 121.117,170.691 120.832,170.973 120.832,170.977
                    120.738,171.07 158.254,208.578 215.516,150.68 200.992,136.152"
                    style={{ fill: color }}
                />
                <polygon
                    fill={color}
                    points="285.144,160.965 285.144,161.016 285.144,161.016 285.144,161.152 391.266,161.152 391.266,146.836
                    285.144,146.836"
                    style={{ fill: color }}
                />
                <polygon
                    fill={color}
                    points="285.144,268.73 285.144,268.782 285.144,268.782 285.144,268.918 391.266,268.918 391.266,254.598
                    285.144,254.598"
                    style={{ fill: color }}
                />
                <polygon
                    fill={color}
                    points="158.211,395.027 135.59,372.402 135.36,372.168 135.36,372.168 135.262,372.074 120.868,386.469
                    120.832,386.504 120.832,386.504 120.738,386.598 158.254,424.11 215.516,366.207 200.992,351.68"
                    style={{ fill: color }}
                />
                <polygon
                    fill={color}
                    points="338.203,192.883 285.277,192.75 285.144,206.934 338.07,206.934"
                    style={{ fill: color }}
                />
                <polygon
                    fill={color}
                    points="201.086,244.012 201.086,244.012 200.992,243.918 158.723,286.742 158.207,287.262 135.48,264.527
                    135.36,264.406 135.36,264.406 135.262,264.309 121.012,278.558 120.832,278.738 120.832,278.738 120.738,278.836 158.254,316.348
                    215.016,258.95 215.422,258.539 215.422,258.539 215.516,258.442 201.121,244.047"
                    style={{ fill: color }}
                />
                <polygon
                    fill={color}
                    points="338.203,300.649 285.277,300.516 285.144,314.695 338.07,314.695"
                    style={{ fill: color }}
                />
                <polygon
                    fill={color}
                    points="285.277,362.359 285.277,362.363 285.144,362.363 285.144,376.492 285.144,376.543 285.144,376.543
                    285.144,376.68 391.266,376.68 391.266,362.363 286.043,362.363"
                    style={{ fill: color }}
                />
                <polygon
                    fill={color}
                    points="285.144,422.461 338.07,422.461 338.203,408.41 285.277,408.274"
                    style={{ fill: color }}
                />
            </g>
        </svg>
    );
};

SettingSellProduct.defaultProps = {
    size: '22px',
    color: '#fff',
};

SettingSellProduct.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const ListLivestreamRegistered = (props) => {
    const { size, color } = props;
    return (
        <Icon
            style={{
                fontSize: size, color,
            }}
            path="M16.54 11L13 7.46l1.41-1.41 2.12 2.12 4.24-4.24 1.41 1.41L16.54 11zM11 7H2v2h9V7zm10 6.41L19.59 12 17 14.59 14.41 12 13 13.41 15.59 16 13 18.59 14.41 20 17 17.41 19.59 20 21 18.59 18.41 16 21 13.41zM11 15H2v2h9v-2z"
        />
    );
};

ListLivestreamRegistered.defaultProps = {
    size: '24px',
    color: '',
};

ListLivestreamRegistered.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const SettingCustomIcon = (props) => {
    const { size, color } = props;
    return (
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" xmlnsSvgjs="http://svgjs.com/svgjs" width={size} height={size} x="0" y="0" viewBox="0 0 128 128" style={{ enableBackground: 'new 0 0 512 512' }} xmlSpace="preserve" className="">
            <g>
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    d="m125.84 75.15c-.57-3.87-1.06-7.22-1.22-9.37-.53-7.18-2.47-11-6.5-12.93a12.05 12.05 0 0 0
                    -5.54-1.13c-.58-2.44-1.76-6.39-3.56-8.17-3.1-3.06-7.35-3.15-9.84-2.86a7.56 7.56 0 0 0 -4.77-4.95 11.62 11.62 0 0 0
                    -8.25.67c-.78-11.95-1.78-22.94-2.92-25.19a5.79 5.79 0 0 0 -4.55-3.44c-3.07-.38-6.08 1.79-7 2.84-.64.74-1.1 1.27-1.06 23 0 10.19.18
                    21.75.33 23.8.13 1.75-.11 8-.39 14a16.29 16.29 0 0 1 -1.27-2.38c-2.26-5-7-9.09-13.21-11.48-4.09-1.56-7.9-1.14-10.21 1.12a5.93 5.93
                    0 0 0 -1.45 6.32c.77 2.14 2.52 4.23 4.54 6.65a45.8 45.8 0 0 1 5 6.79 54.85 54.85 0 0 1 3.33 7.82 50.68 50.68 0 0 0 4 9c.75 1.24 1.57
                    2.55 2.41 3.9a124.78 124.78 0 0 1 7 12.24c2.49 5.43 11.53 10 12.55 10.56a2 2 0 1 0 1.74-3.6c-2.43-1.21-9.08-5.12-10.7-8.65a125.45
                    125.45 0 0 0 -7.3-12.71c-.83-1.33-1.64-2.63-2.38-3.86a47 47 0 0 1 -3.62-8.22 57.77 57.77 0 0 0 -3.59-8.39 48.86 48.86 0 0 0
                    -5.41-7.4c-1.71-2-3.32-4-3.85-5.44a1.92 1.92 0 0 1 .49-2.1c.9-.88 2.94-1.4 6-.24 7.1 2.71 9.93 7 11 9.39a16.48 16.48 0 0 0 4.64
                    6.33c-.1 1.82-.18 3.43-.25 4.61a2 2 0 0 0 1.88 2.11h.09a2 2 0 0 0 2-1.88c0-.86 1.2-21 .92-24.78-.32-4.69-.51-39.43.08-44.13a5.12 5.12
                    0 0 1 3.19-1.22c.24 0 .88.11 1.46 1.27.91 1.86 2 14.52 2.88 30.08v.27s0 .05 0 .08c.48 8.26.9 17.33 1.23 26a2 2 0 1 0
                    4-.15c-.15-4-.6-15.27-1.28-26.86a2.62 2.62 0 0 1 1-2.18c1.48-1.17 4.28-1.17 5.66-.73 2.2.71 2.5 3.5 2.51 3.61s0 0 0 0c0
                    .18 1.78 18.59 2 22.77a2 2 0 0 0 2 1.89h.12a2 2 0 0 0 1.88-2.11c-.2-3.5-1.4-16.25-1.85-21.07 1.74-.17 4.5-.08 6.37 1.76
                    1.15 1.13 2.35 5.3 2.84 7.9v.07s0 .05 0 .08a41.85 41.85 0 0 1 1.06 12.93 2 2 0 0 0 1.79 2.19h.2a2 2 0 0 0 2-1.8 44 44 0
                    0 0 -.67-12 8 8 0 0 1 3 .74c2.18 1 3.72 3 4.21 9.6.17 2.29.67 5.7 1.25 9.65 1.07 7.32 2.41 16.43 2.12 22-.44 8.44-3.91
                    21.34-3.94 21.47a2 2 0 0 0 .25 1.6l4 6.28a2 2 0 0 0 3.37-2.15l-3.54-5.54c.8-3.1 3.45-13.78 3.85-21.45.35-5.98-1.02-15.33-2.12-22.83z"
                    fill={color}
                    data-original="#000000"
                    className=""
                />
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    d="m2 16h58.22a13.49 13.49 0 0 0 3.78 7.24 2 2 0 0 0 2.83-2.83 9.59 9.59 0 0 1 10.41-15.65 2 2 0 1 0 1.52-3.7 13.58 13.58 0 0
                    0 -18.65 10.94h-58.11a2 2 0 0 0 0 4z"
                    fill={color}
                    data-original="#000000"
                    className=""
                />
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    d="m90 12a2 2 0 0 0 0 4h36a2 2 0 0 0 0-4z"
                    fill={color}
                    data-original="#000000"
                    className=""
                />
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    d="m14 78a14 14 0 0 0 13.84-12h10.16a2 2 0 0 0 0-4h-10.16a14 14 0 1 0 -13.84 16zm0-24a10 10 0 1 1 -10 10 10 10 0 0 1 10-10z"
                    fill={color}
                    data-original="#000000"
                    className=""
                />
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    d="m2 116h28.16a14 14 0 0 0 27.68 0h7.16a2 2 0 0 0 0-4h-7.16a14 14 0 0 0 -27.68 0h-28.16a2 2 0 0 0 0 4zm42-12a10 10 0 1 1 -10 10 10 10 0 0 1 10-10z"
                    fill={color}
                    data-original="#000000"
                    className=""
                />
            </g>
        </svg>
    );
};

SettingCustomIcon.defaultProps = {
    size: '22px',
    color: '#fff',
};

SettingCustomIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const ArrowDown = (props) => {
    const { size, color } = props;
    return (
        <svg focusable="false" aria-hidden="true" viewBox="0 0 24 24" width={size} height={size}>
            <path d="M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z" fill={color} />
        </svg>
    );
};

ArrowDown.defaultProps = {
    size: '24px',
    color: '',
};

ArrowDown.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const ArrowUp = (props) => {
    const { size, color } = props;
    return (
        <svg focusable="false" aria-hidden="true" viewBox="0 0 24 24" width={size} height={size}>
            <path d="M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z" fill={color} />
        </svg>
    );
};

ArrowUp.defaultProps = {
    size: '24px',
    color: '',
};

ArrowUp.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const AddIcon = (props) => {
    const { size, color } = props;
    return (
        <svg focusable="false" viewBox="0 0 24 24" aria-hidden="true" width={size} height={size}>
            <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" fill={color} />
        </svg>
    );
};

AddIcon.defaultProps = {
    size: '24px',
    color: '',
};

AddIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const RemoveIcon = (props) => {
    const { size, color } = props;
    return (
        <svg focusable="false" viewBox="0 0 24 24" aria-hidden="true" width={size} height={size}>
            <path d="M19 13H5v-2h14v2z" fill={color} />
        </svg>
    );
};

RemoveIcon.defaultProps = {
    size: '24px',
    color: '',
};

RemoveIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const ZoomIn = (props) => {
    const { size, color } = props;
    return (
        <svg focusable="false" viewBox="0 0 24 24" aria-hidden="true" width={size} height={size}>
            <path
                d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11
                16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59
                4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5
                9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
                fill={color}
            />
            <path d="M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z" fill={color} />
        </svg>
    );
};

ZoomIn.defaultProps = {
    size: '24px',
    color: '',
};

ZoomIn.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const NextIcon = (props) => {
    const { size, color } = props;
    return (
        <svg focusable="false" viewBox="0 0 24 24" aria-hidden="true" width={size} height={size}>
            <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" fill={color} />
        </svg>
    );
};

NextIcon.defaultProps = {
    size: '24px',
    color: '',
};

NextIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const PrevIcon = (props) => {
    const { size, color } = props;
    return (
        <svg focusable="false" viewBox="0 0 24 24" aria-hidden="true" width={size} height={size}>
            <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" fill={color} />
        </svg>
    );
};

PrevIcon.defaultProps = {
    size: '24px',
    color: '',
};

PrevIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const HomeIcon = (props) => {
    const { size, color } = props;
    return (
        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1" width={size} height={size} viewBox="0 0 256 256" xmlSpace="preserve">
            <g
                style={{
                    stroke: 'none',
                    strokeWidth: 0,
                    strokeDasharray: 'none',
                    strokeLinecap: 'butt',
                    strokeLinejoin: 'miter',
                    strokeMiterlimit: 10,
                    fill: 'none',
                    fillRule: 'nonzero',
                    opacity: 1,
                }}
                transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
            >
                <polygon
                    points="75.96,30.96 75.96,13.34 67.26,13.34 67.26,22.26 45,0 0.99,44.02 7.13,50.15 45,12.28 82.88,50.15 89.01,44.02 "
                    style={{
                        stroke: 'none',
                        strokeWidth: 1,
                        strokeDasharray: 'none',
                        strokeLinecap: 'butt',
                        strokeLinejoin: 'miter',
                        strokeMiterlimit: 10,
                        fill: color,
                        fillRule: 'nonzero',
                        opacity: 1,
                    }}
                    transform="  matrix(1 0 0 1 0 0) "
                />
                <polygon
                    points="45,20 14.04,50.95 14.04,90 35.29,90 35.29,63.14 54.71,63.14 54.71,90 75.96,90 75.96,50.95 "
                    style={{
                        stroke: 'none',
                        strokeWidth: 1,
                        strokeDasharray: 'none',
                        strokeLinecap: 'butt',
                        strokeLinejoin: 'miter',
                        strokeMiterlimit: 10,
                        fill: color,
                        fillRule: 'nonzero',
                        opacity: 1,
                    }}
                    transform="  matrix(1 0 0 1 0 0) "
                />
            </g>
        </svg>
    );
};

HomeIcon.defaultProps = {
    size: '24px',
    color: 'rgb(0,0,0)',
};

HomeIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const PreviewIcon = (props) => {
    const { size, color } = props;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 480.606 480.606"
            style={{ enableBackground: 'new 0 0 480.606 480.606', width: size, height: size }}
            xmlSpace="preserve"
        >
            <g>
                <rect x="85.285" y="192.5" width="200" height="30" fill={color} />
                <path
                    d="M439.108,480.606l21.213-21.213l-71.349-71.349c12.528-16.886,19.949-37.777,19.949-60.371
                    c0-40.664-24.032-75.814-58.637-92.012V108.787L241.499,0H20.285v445h330v-25.313c6.188-2.897,12.04-6.396,17.475-10.429
                    L439.108,480.606z M250.285,51.213L299.072,100h-48.787V51.213z M50.285,30h170v100h100v96.957
                    c-4.224-0.538-8.529-0.815-12.896-0.815c-31.197,0-59.148,14.147-77.788,36.358H85.285v30h126.856
                    c-4.062,10.965-6.285,22.814-6.285,35.174c0,1.618,0.042,3.226,0.117,4.826H85.285v30H212.01
                    c8.095,22.101,23.669,40.624,43.636,52.5H50.285V30z M307.389,399.208c-39.443,0-71.533-32.09-71.533-71.533
                    s32.089-71.533,71.533-71.533s71.533,32.089,71.533,71.533S346.832,399.208,307.389,399.208z"
                    fill={color}
                />
            </g>
        </svg>
    );
};

PreviewIcon.defaultProps = {
    size: '24px',
    color: 'rgb(0,0,0)',
};

PreviewIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const LanguageSetting = (props) => {
    const { size, color } = props;
    return (
        <svg
            version="1.0"
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 512.000000 512.000000"
            preserveAspectRatio="xMidYMid meet"
        >
            <g
                transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                fill={color}
                stroke="none"
            >
                <path d="M1830 4843 c-384 -60 -739 -214 -1039 -451 -180 -143 -381 -379 -506
                -596 -425 -741 -370 -1653 144 -2344 85 -114 312 -340 426 -425 315 -233 688
                -379 1063 -418 155 -16 423 -7 574 20 159 28 374 99 594 197 7 3 32 -30 57
                -73 97 -168 176 -204 358 -162 72 16 106 20 118 12 9 -5 31 -54 48 -109 38
                -117 75 -166 147 -200 48 -23 62 -24 250 -24 182 0 203 2 243 21 71 35 114 93
                148 204 17 54 38 103 47 108 11 8 45 4 117 -12 121 -28 166 -24 242 22 48 28
                62 45 126 152 119 199 128 220 128 300 -1 78 -22 131 -70 175 -35 32 -105 119
                -105 131 0 4 30 41 66 81 36 40 75 90 85 111 26 49 34 121 20 172 -10 40 -145
                285 -183 335 -31 39 -95 78 -151 90 -45 10 -64 9 -140 -9 -102 -24 -131 -26
                -145 -8 -5 6 -20 46 -32 87 -39 132 -75 181 -160 219 l-45 20 3 208 c4 241
                -10 370 -62 575 -75 299 -221 590 -413 828 -130 161 -345 350 -522 460 -157
                97 -405 210 -462 210 -58 0 -106 -73 -87 -132 14 -39 33 -52 138 -93 119 -46
                238 -109 357 -189 l93 -61 0 -159 0 -159 -114 -116 c-62 -64 -122 -132 -132
                -151 -16 -30 -19 -63 -22 -221 -4 -209 2 -247 51 -311 41 -53 97 -85 173 -99
                57 -10 62 -14 180 -130 166 -163 164 -163 423 -167 l204 -4 -5 -133 c-3 -73
                -8 -138 -12 -144 -4 -7 -41 -11 -94 -11 -104 0 -151 -18 -211 -80 -33 -35 -46
                -60 -71 -140 -17 -54 -37 -103 -45 -110 -16 -14 -45 -11 -159 14 -108 23 -191
                1 -257 -71 -42 -45 -187 -304 -198 -355 -11 -49 -2 -129 20 -170 7 -12 43 -55
                80 -95 41 -43 69 -81 69 -93 0 -13 -26 -49 -64 -88 -81 -85 -108 -138 -110
                -217 l-2 -60 -99 -42 c-55 -23 -103 -43 -106 -43 -3 0 -9 23 -12 50 -9 77 -49
                139 -162 249 -72 72 -119 109 -161 128 -56 26 -67 28 -199 28 -131 0 -144 -2
                -197 -27 -38 -18 -91 -59 -162 -127 -96 -93 -108 -101 -143 -101 -101 0 -211
                -63 -260 -148 -14 -26 -28 -49 -29 -51 -5 -6 -109 37 -198 82 -503 249 -877
                711 -1016 1254 -111 437 -63 912 134 1318 47 96 121 222 146 249 5 5 96 -66
                204 -158 162 -138 197 -173 207 -204 6 -22 9 -92 7 -173 l-3 -136 -78 -84
                c-44 -46 -91 -106 -105 -134 l-27 -50 0 -265 c0 -255 1 -267 23 -316 19 -41
                86 -113 340 -366 362 -360 354 -355 502 -346 97 6 167 42 223 114 58 75 69
                130 65 302 -4 169 -16 204 -97 294 -41 46 -46 57 -46 99 l0 48 286 288 c213
                215 292 301 310 338 23 49 24 56 24 305 0 248 -1 256 -24 300 -32 61 -86 116
                -146 148 -50 27 -51 27 -325 32 -261 5 -277 6 -305 26 -53 39 -254 251 -260
                275 -3 13 -4 92 -3 174 l3 150 85 34 c108 42 315 95 456 116 120 17 154 34
                168 83 11 40 1 78 -29 108 -20 20 -33 24 -82 23 -32 -1 -69 -3 -83 -6z m-692
                -778 c32 -69 307 -345 377 -377 47 -22 65 -23 320 -28 295 -5 314 -9 335 -66
                6 -14 10 -116 10 -226 l0 -201 -284 -286 c-331 -334 -340 -347 -340 -481 0
                -101 18 -146 92 -230 l47 -54 0 -132 c0 -127 -1 -134 -24 -158 -30 -32 -76
                -46 -116 -34 -35 9 -588 556 -605 599 -7 17 -10 102 -8 242 l3 215 78 80 c50
                52 87 100 104 138 26 55 28 70 31 215 5 183 -6 249 -51 316 -19 28 -115 119
                -234 222 l-203 174 43 50 c54 65 198 191 307 268 l85 61 5 -129 c5 -104 10
                -137 28 -178z m2471 -90 c221 -265 367 -580 427 -920 8 -44 14 -83 14 -87 0
                -5 -77 -8 -170 -8 -129 0 -178 4 -198 14 -15 8 -74 62 -132 121 -126 127 -151
                144 -232 155 -40 6 -67 15 -75 26 -9 13 -13 63 -13 172 l0 155 114 116 c139
                140 155 172 156 290 0 99 -4 100 109 -34z m629 -1717 c5 -7 20 -49 32 -93 27
                -97 40 -123 82 -165 71 -71 167 -87 308 -50 64 16 78 17 95 6 23 -16 165 -258
                165 -282 0 -9 -30 -48 -66 -87 -82 -86 -108 -141 -108 -222 1 -77 26 -127 110
                -216 35 -37 64 -75 64 -84 0 -20 -136 -258 -160 -280 -18 -17 -24 -16 -104 4
                -133 33 -203 26 -274 -26 -54 -40 -87 -95 -111 -184 -13 -46 -28 -90 -33 -96
                -8 -10 -56 -13 -180 -13 l-169 0 -13 33 c-8 17 -20 56 -27 86 -46 185 -175
                253 -377 202 -61 -16 -87 -19 -102 -11 -30 16 -172 273 -164 296 4 10 37 51
                74 90 134 142 135 265 1 407 -37 40 -71 80 -74 90 -8 23 135 282 164 298 13 7
                42 4 98 -11 87 -22 165 -26 208 -9 89 33 140 98 175 221 31 112 24 108 213
                108 118 0 165 -3 173 -12z m-1877 -1085 c23 -4 59 -31 117 -87 97 -94 112
                -117 112 -184 l0 -49 -93 -16 c-159 -29 -306 -40 -443 -33 -132 6 -361 39
                -377 55 -11 11 30 50 58 56 11 2 42 6 70 9 77 9 130 42 239 146 56 54 110 100
                121 103 31 7 158 8 196 0z"
                />
                <path d="M3995 1810 c-164 -25 -302 -142 -355 -300 -70 -208 26 -441 222 -539
                268 -134 584 28 640 328 22 115 -20 265 -101 362 -90 108 -262 171 -406 149z
                m175 -220 c84 -44 134 -126 134 -220 0 -143 -101 -244 -244 -244 -72 0 -114
                17 -168 68 -61 57 -87 138 -71 223 29 155 210 245 349 173z"
                />
                <path d="M2314 4816 c-46 -46 -46 -86 0 -132 36 -36 67 -42 111 -22 69 31 71
                139 4 174 -45 23 -78 17 -115 -20z"
                />
            </g>
        </svg>
    );
};

LanguageSetting.defaultProps = {
    size: '24px',
    color: '#fff',
};
LanguageSetting.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};

export const LanguageIcon = (props) => {
    const { size, color } = props;
    return (
        <svg width={size} height={size} viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M 28.0234 51.2734 C 40.7500 51.2734 51.2735 40.7266 51.2735 28 C 51.2735 15.2968 40.7265 4.7266 28.0000
            4.7266 C 15.2734 4.7266 4.7265 15.2968 4.7265 28 C 4.7265 40.7266 15.2968 51.2734 28.0234 51.2734 Z M
            21.2734 15.8594 C 22.6562 12.3672 24.5546 9.8594 26.6406 9.0859 L 26.6406 16.3984 C 24.7187 16.3516 22.9141 16.1641
            21.2734 15.8594 Z M 29.3359 9.0859 C 31.4219 9.8594 33.3437 12.3672 34.7031 15.8594 C 33.0625 16.1641 31.2812 16.3516
            29.3359 16.3984 Z M 34.2812 9.7422 C 36.7890 10.6094 39.0625 11.9453 40.9609 13.7031 C 39.9297 14.2890 38.7343 14.7812
            37.3984 15.2031 C 36.5546 13.0234 35.4765 11.1719 34.2812 9.7422 Z M 15.0156 13.7031 C 16.9375 11.9688 19.2109 10.6094
            21.7187 9.7422 C 20.5000 11.1719 19.4453 13.0234 18.5781 15.2031 C 17.2656 14.7812 16.0703 14.2890 15.0156 13.7031 Z M
            39.6250 26.6406 C 39.5078 23.3828 39.0156 20.3594 38.2422 17.6875 C 40.0000 17.1484 41.5468 16.4688 42.8594 15.6719 C
            45.3437 18.6719 46.9609 22.4688 47.2422 26.6406 Z M 8.7578 26.6406 C 9.0390 22.4688 10.6328 18.6719 13.1406 15.6719 C
            14.4297 16.4688 16.0000 17.1484 17.7343 17.6875 C 16.9609 20.3594 16.4922 23.3828 16.3750 26.6406 Z M 29.3359 26.6406 L
            29.3359 19.0937 C 31.5390 19.0234 33.6250 18.7656 35.5703 18.3672 C 36.2734 20.8750 36.7422 23.6875 36.8594 26.6406 Z M
            19.1406 26.6406 C 19.2343 23.6875 19.7031 20.8750 20.4297 18.3672 C 22.3515 18.7656 24.4609 19.0234 26.6406 19.0937 L 26.6406
            26.6406 Z M 8.7578 29.3359 L 16.3750 29.3359 C 16.4687 32.6406 16.9609 35.7344 17.7343 38.4297 C 16.0234 38.9688 14.4765
            39.6250 13.1875 40.4219 C 10.6562 37.3750 9.0390 33.5547 8.7578 29.3359 Z M 19.1172 29.3359 L 26.6406 29.3359 L 26.6406 37.0234
            C 24.4609 37.0937 22.3515 37.3281 20.4297 37.75 C 19.7031 35.2188 19.2343 32.3359 19.1172 29.3359 Z M 29.3359 37.0234 L 29.3359
            29.3359 L 36.8594 29.3359 C 36.7656 32.3359 36.2968 35.2188 35.5703 37.75 C 33.6250 37.3281 31.5390 37.0937 29.3359 37.0234 Z M
            38.2422 38.4297 C 39.0390 35.7344 39.5078 32.6406 39.6250 29.3359 L 47.2422 29.3359 C 46.9843 33.5547 45.3672 37.3984 42.8125 40.4219
            C 41.5234 39.6484 39.9765 38.9688 38.2422 38.4297 Z M 21.2734 40.2578 C 22.9141 39.9531 24.7187 39.7656 26.6406 39.7188 L 26.6406
            47.0312 C 24.5546 46.2578 22.6562 43.7500 21.2734 40.2578 Z M 29.3359 39.7188 C 31.2812 39.7656 33.0625 39.9531 34.7031 40.2578 C
            33.3437 43.7500 31.4219 46.2578 29.3359 47.0312 Z M 15.0859 42.3672 C 16.1172 41.8047 17.2890 41.3125 18.5781 40.9141 C 19.4219 43.0234
            20.4297 44.8047 21.6015 46.2344 C 19.1641 45.3906 16.9609 44.0547 15.0859 42.3672 Z M 37.3984 40.9141 C 38.7109 41.3125 39.8828 41.8047
            40.9141 42.3906 C 39.0390 44.0781 36.8125 45.4141 34.3750 46.2578 C 35.5468 44.8281 36.5781 43.0234 37.3984 40.9141 Z"
                fill={color}
            />
        </svg>
    );
};

LanguageIcon.defaultProps = {
    size: '24px',
    color: 'rgb(0,0,0)',
};

LanguageIcon.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
};
